module.exports = __webpack_public_path__ + "assets/img/img209.3621e360.png";